import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { RoleAssignment, RoleAssignmentRequest } from "../model/RoleAssignment";
import { CurrentUserRoles } from "../model/CurrentUserRoles";
import { ContextService } from "./context.service";

@Injectable({
  providedIn: "root",
})
export class RolesService {
  constructor(private http: HttpClient, private context: ContextService) {}

  private get baseUrl(): string {
    return this.context._configurationEnvironment.service_engine_base_url + "roles";
  }

  private get authHeaders(): { [header: string]: string } {
    const token = localStorage.getItem("access_token") || "";
    return { Authorization: `Bearer ${token}` };
  }

  me(): Observable<CurrentUserRoles> {
    return this.http.get<CurrentUserRoles>(`${this.baseUrl}/me`, {
      headers: this.authHeaders,
    });
  }

  listForOrganization(organizationId: number): Observable<RoleAssignment[]> {
    return this.http.get<RoleAssignment[]>(
      `${this.baseUrl}?organizationId=${organizationId}`,
      { headers: this.authHeaders },
    );
  }

  listForFacility(facilityId: number): Observable<RoleAssignment[]> {
    return this.http.get<RoleAssignment[]>(
      `${this.baseUrl}?facilityId=${facilityId}`,
      { headers: this.authHeaders },
    );
  }

  listSuperadmins(): Observable<RoleAssignment[]> {
    return this.http.get<RoleAssignment[]>(`${this.baseUrl}?role=SUPERADMIN`, {
      headers: this.authHeaders,
    });
  }

  assign(request: RoleAssignmentRequest): Observable<RoleAssignment> {
    return this.http.post<RoleAssignment>(this.baseUrl, request, {
      headers: this.authHeaders,
    });
  }

  remove(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, {
      headers: this.authHeaders,
    });
  }
}
